export default "__VITE_ASSET__969a9ce2__"